<script lang="ts">
    
    import { fly } from "svelte/transition";
    import { createEventDispatcher, getContext } from "svelte";
    import type { AnyActivity, OpenActivity } from "../../global";
    import type { Checkpoint } from "../../Model/Checkpoint";
    import IconClose from "../Shared/IconClose.svelte";
    import ActivityBtn from "../Shared/ActivityBtn.svelte";
    import IconChat from "../Shared/IconChat.svelte";
    import IconInfo from "../Shared/IconInfo.svelte";
    import IconGears from "../Shared/IconGears.svelte";
    import IconGallery from "../Shared/IconGallery.svelte";
    import IconImage360 from "../Shared/IconImage360.svelte";

    export let checkpoint: Checkpoint;

    const dispatch = createEventDispatcher();
    const openActivity: OpenActivity = getContext('openActivity');

    function onClose(): void {
        dispatch('close');
    }

    function onActivityClick({ detail: activity }: CustomEvent<AnyActivity>): void {
        openActivity(activity);
    }

</script>

<div class="checkpoint-modal" transition:fly={{ y: -30 }}>
    <div class="dialog">
        <button type="button" class="close-btn" on:click={onClose}>
            <IconClose size="20px" />
        </button>
        <div class="name">{checkpoint.name}</div>
        <div class="description">{checkpoint.description}</div>

        <div class="activities">

            {#if checkpoint.activities.chat}
                <ActivityBtn activity={checkpoint.activities.chat} on:click={onActivityClick}>
                    <IconChat color="#fff" size={25} />
                </ActivityBtn>
            {/if}

            {#if checkpoint.activities.info}
                <ActivityBtn activity={checkpoint.activities.info} on:click={onActivityClick}>
                    <IconInfo color="#fff" size={7} />
                </ActivityBtn>
            {/if}

            {#if checkpoint.activities.secret}
                <ActivityBtn activity={checkpoint.activities.secret} on:click={onActivityClick}>
                    <IconGears color="#fff" size={23} />
                </ActivityBtn>
            {/if}

            {#if checkpoint.activities.gallery}
                <ActivityBtn activity={checkpoint.activities.gallery} on:click={onActivityClick}>
                    <IconGallery color="#fff" size={23} />
                </ActivityBtn>
            {/if}

            {#if checkpoint.activities.image360}
                <ActivityBtn activity={checkpoint.activities.image360} on:click={onActivityClick}>
                    <IconImage360 color="#fff" size={28} />
                </ActivityBtn>
            {/if}

        </div>

    </div>
    <div class="arrow"></div>
</div>

<style lang="scss">

    .checkpoint-modal {
        display: flex;
        flex-direction: column;
        align-items: center;
        pointer-events: none;
        touch-action: none;
        filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.25));
    }

    .dialog {
        background-color: #fff;
        box-sizing: border-box;
        width: calc(100% - 30px);
        border-radius: 10px;
        max-width: 300px;
        padding: 1rem;
        pointer-events: auto;
        touch-action: auto;
        position: relative;
    }

    .close-btn {
        width: 40px;
        height: 40px;
        background-color: #fff;
        border: none;
        border-radius: 50%;
        position: absolute;
        top: -15px;
        right: -15px;
        padding: 0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .name {
        font-size: 2rem;
        text-align: center;
    }

    .description {
        text-align: center;
    }

    .activities {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        gap: 3px;
    }

    .arrow {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 20px 15px 0 15px;
        border-color: #ffffff transparent transparent transparent;
    }

</style>
